import { ref, watch } from 'vue';
import { useToast } from '@/composables/common/useToast';
import { useBaseDeportistaWizard, COUNTRY_CODES } from './useBaseDeportistaWizard';
import { guardarDocumentos as guardarDocumentosService } from '@/services/admin/bases/crearDeportista';

const toast = useToast();

/**
 * useCrearDeportista — Orquestador del wizard de CREACIÓN de deportistas.
 * Delega toda la lógica compartida en useBaseDeportistaWizard.
 *
 * DIFERENCIAS con el base:
 *  - Steps incluye 'Documentación'
 *  - autoSelectCategoria activado
 *  - Expone guardarDocumentos() y countryCodes
 *
 * @param {number} listaId
 * @returns {object}
 */
export function useCrearDeportista(listaId) {
    // Steps como writable ref — la reactividad la mantiene el watch
    const steps = ref([]);

    const base = useBaseDeportistaWizard(listaId, {
        steps,
        autoSelectCategoria: true,
    });

    // ── Steps dinámicos según categoría seleccionada ──
    watch(() => base.selectedCategoria.value, cat => {
        const s = [
            'Jugador',
            'Responsables',
            'Documentación',
        ];

        if (cat?.tiene_indumentarias) {
            s.push('Indumentarias');
        }

        s.push('Descuentos', 'Confirmación');
        steps.value = s;
    }, { immediate: true });

    // ── Guardar documentos (paso 3 — solo crear) ──
    async function guardarDocumentos(documentosId, fotoUrl) {
        base.setSubmitting(true);
        base.setError(null);

        const payload = {
            lista_id: listaId,
            session_id: base.sessionId.value,
            documentos_id: documentosId || [],
            foto_url: fotoUrl || null,
            filters: {},
        };

        try {
            await guardarDocumentosService(payload);
            base.advanceStep();
        } catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.error(err);
            }
            base.setError(err);
            toast.error('Error al guardar la documentación');
        } finally {
            base.setSubmitting(false);
        }
    }

    return {
        ...base,
        steps,
        guardarDocumentos,
        countryCodes: COUNTRY_CODES,
    };
}
